
import FormDialog from "../../helpers/FormDialog";

export const ReferenceEdit = ({
    onSuccess,
    setOpen,
    open,
    resourceId,
    setValue0,
    value,
}) => {
    return (
        <FormDialog
            maxWidth={"md"}
            open={open > 0}
            onSuccess={onSuccess}
            setOpen={setOpen}
            url={open === 1 ? "/api/resource/reference/:resourceId" : `/api/resource/reference/update/${resourceId}`}
            title={open === 1 ? "Create Education" : "Edit References"}
            fields={[
                {
                    name: "referees",
                    label: "Referees",
                    type: "array",
                    value: value["referees"],
                    setValue: (val) => setValue0("referees", val),
                    itemLabel: (index, values) => {
                        const record = values[index];
                        return `Referee #${index + 1}`;
                    },
                    fields: [
                        {
                            name: "relationship", 
                            label: "Relationship",
                            type: "select",
                            values: [
                                { value: "professional", label: "Professional" },
                                { value: "academic", label: "Academic" },
                                { value: "personal", label: "Personal" },
                                { value: "other", label: "Other" },
                            ],
                            required: true,
                            value: value["relationship"],
                            setValue: (val, index) => {
                                const referees = Array.isArray(value["referees"]) ? value["referees"] : [];
                                const updatedRecords = [...referees];
                                updatedRecords[index] = { ...updatedRecords[index], relationship: val };
                                setValue0("referees", updatedRecords);
                            },
                        },
                        {
                            name: "customRelationship",
                            label: "Specify Relationship",
                            type: "text",
                            required: true,
                            value: value["customRelationship"],
                            setValue: (val, index) => {
                                const referees = Array.isArray(value["referees"]) ? value["referees"] : [];
                                const updatedRecords = [...referees];
                                updatedRecords[index] = { ...updatedRecords[index], customRelationship: val };
                                setValue0("referees", updatedRecords);
                            },
                            showIf: (values, index) => {
                                const referees = Array.isArray(values["referees"]) ? values["referees"] : [];
                                return referees[index]?.relationship === "other"; 
                            },
                        },
                        {
                            name: "name",  
                            label: "Name",
                            type: "text",
                            value: value["name"],
                            required: true,
                            setValue: (val, index) => {
                                const referees = Array.isArray(value["referees"]) ? value["referees"] : [];
                                const updatedRecords = [...referees];
                                updatedRecords[index] = { ...updatedRecords[index], name: val };
                                setValue0("referees", updatedRecords);
                            },
                        },
                        {
                            name: "address",  
                            label: "Address",
                            type: "text",
                            value: value["address"],
                            required: true,
                            setValue: (val, index) => {
                                const referees = Array.isArray(value["referees"]) ? value["referees"] : [];
                                const updatedRecords = [...referees];
                                updatedRecords[index] = { ...updatedRecords[index], address: val };
                                setValue0("referees", updatedRecords);
                            },
                        },
                        {
                            name: "phone",  
                            label: "Phone Number",
                            type: "text",
                            value: value["phone"],
                            required: true,
                            setValue: (val, index) => {
                                const referees = Array.isArray(value["referees"]) ? value["referees"] : [];
                                const updatedRecords = [...referees];
                                updatedRecords[index] = { ...updatedRecords[index], phone: val };
                                setValue0("referees", updatedRecords);
                            },
                        },
                       
                    ],
                },
            ]}
        />
    );
};